import * as types from "./actionTypes";
import { apiRequestAnonymous } from "../utils/request";
import { configureUserManager } from "../utils/userManager";

export function loadConfigSuccess(
  styleName,
  companyName,
  truckProxyUri,
  gst,
  instance,
  passwordStrength,
  tenant,
  clientId,
  scope,
  authority,
  subscriptionId,
  autoApproveUrgentRunEstimate,
  litres,
  standardMonths,
  vacuumMonths,
  siteUrl
) {
  return {
    type: types.LOAD_API_CONFIG_SUCCESS,
    styleName,
    companyName,
    truckProxyUri,
    gst,
    instance,
    passwordStrength,
    tenant,
    clientId,
    scope,
    authority,
    subscriptionId,
    autoApproveUrgentRunEstimate,
    litres,
    standardMonths,
    vacuumMonths,
    siteUrl
  };
}

export function loadApiConfig() {
  return function (dispatch, getState) {
    return apiRequestAnonymous(`/api/config`).then((x) => {
      localStorage.setItem("configs", JSON.stringify(x.data));
      // The userManager singleton was built before this fetch, from whatever localStorage held at
      // the time. Fill it in now, while nothing has rendered yet, so the first sign-in on a browser
      // that has never loaded the app works instead of throwing.
      configureUserManager(x.data);
      return dispatch(
        loadConfigSuccess(
          x.data.styleName,
          x.data.companyName,
          x.data.truckProxyUri,
          x.data.gst,
          x.data.instance,
          x.data.passwordStrength,
          x.data.tenant,
          x.data.clientId,
          x.data.scope,
          x.data.authority,
          x.data.subscriptionId,
          x.data.autoApproveUrgentRunEstimate,
          x.data.autoApproveLitres,
          x.data.autoApproveStandardMonths,
          x.data.autoApproveVacuumMonths,
          x.data.siteUrl
        )
      );
    });
  };
}
